import GitHubCalendar from 'react-github-calendar';
import "../component_style/git.css"
export default function Git(){
    return (
        <>
        <br/>
        <h2 className='gitHead' ><b>GitHub Stats</b></h2>
        <br/>
        <div>
            
            <img className="git_stack" src="http://github-profile-summary-cards.vercel.app/api/cards/stats?username=Nikhil-81&theme=gruvbox" />
        </div>
        <br/>
        <div>
            <img  className="git_stack" src="http://github-profile-summary-cards.vercel.app/api/cards/productive-time?username=Nikhil-81&theme=gruvbox&utcOffset=8" />
        </div>
        <div className='Git_call' >
        <GitHubCalendar color="orange" username="Nikhil-81" />
        </div>
        </>
    )
}